import React from 'react';

interface InfoFieldProps {
	label: string;
	value?: string | number | null;
	subValue?: string;
}

export function InfoField({ label, value, subValue }: InfoFieldProps) {
	return (
		<div className="space-y-1">
			<div className="text-sm text-gray-600">{label}</div>
			<div className="text-gray-900">{value ?? '-'}</div>
			{subValue && <div className="text-sm text-gray-600">{subValue}</div>}
		</div>
	);
}
